import { JsonPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { Option } from '@interfaces/common/option';
import { TranslateService } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { VaultBaseComponent } from '@src/app/shared/components/base/vault-base.component';
import { SharedModule } from '@src/app/shared/shared.module';

@Component({
  templateUrl: './in-development.component.html',
  styleUrls: ['./in-development.component.scss'],
  imports: [SharedModule, FormsModule, JsonPipe, RouterLink],
})
export class InDevelopmentComponent extends VaultBaseComponent {
  // Opções de teste
  testOptions: Option[] = [
    { label: 'Opção 1', value: '1' },
    { label: 'Opção 2', value: '2' },
    { label: 'Opção 3', value: '3' },
    { label: 'Opção 4', value: '4' },
    { label: 'Opção 5', value: '5' },
  ];

  // Para ngModel
  selectedOptionsNgModel: string[] = [];

  // Para FormGroup
  testForm: FormGroup;

  constructor(
    translateService: TranslateService,
    private fb: FormBuilder
  ) {
    super(translateService);
    this.testForm = this.fb.group({
      selectedOptions: [[]],
    });
  }
}
